import { Injectable } from '@angular/core';
import { ToastService } from '@services/ui-services/toast.service';

const SUCCESS_TOAST_SETUP: any = {
  name: '',
  message: '',
  info: '',
  time: '',
  toastIcons: {
    success: 'check',
    avatar: 'type',
  },
  type: 'success',
  State: 'default',
  primaryButton: false,
  secondaryButton: false,
  showControls: false,
};

const ERROR_TOAST_SETUP: any = {
  name: '',
  message: '',
  info: '',
  time: '',
  toastIcons: {
    cancel: 'cancel',
    avatar: 'type',
  },
  type: 'cancel',
  State: 'default',
  primaryButton: false,
  secondaryButton: false,
  showControls: false,
};

export interface NotifyConfig {
  name?: string;
  type?: string;
  toastIcons: {
    error: string;
    avatar: string;
  };
}

@Injectable({ providedIn: 'root' })
export class NotifyService {
  constructor(private readonly toastService: ToastService) {}

  success(message: string, config?: NotifyConfig) {
    const params = { ...SUCCESS_TOAST_SETUP, ...(config || {}), message };
    this.toastService.showToast(params);
  }

  error(message: string, config?: NotifyConfig) {
    const params = { ...ERROR_TOAST_SETUP, ...(config || {}), message };
    this.toastService.showToast(params);
  }
}
